import React, { Component } from "react";
import Helmet from "react-helmet";
import { Grid, Segment, Container } from "semantic-ui-react";
import styles from "../components/Cleanings/cleaning.module.css";
class FreeCleanings extends Component {
  render() {
    return (
      <div className={styles.successGradient}>
        <Container style={{ paddingTop: "15vh" }} text>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Segment fluid raised>
                  <h2>
                    Coming soon - Get a free cleaning by referring your friends!
                  </h2>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default FreeCleanings;



// WEBPACK FOOTER //
// ./src/pages/freecleanings.jsx